/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalSearchGroupDto } from './GlobalSearchGroupDto';
import {
    GlobalSearchGroupDtoFromJSON,
    GlobalSearchGroupDtoFromJSONTyped,
    GlobalSearchGroupDtoToJSON,
    GlobalSearchGroupDtoToJSONTyped,
} from './GlobalSearchGroupDto';

/**
 * 
 * @export
 * @interface GlobalSearchResponse
 */
export interface GlobalSearchResponse {
    /**
     * Groupes non vides, triés par pertinence métier (ordre à respecter)
     * @type {Array<GlobalSearchGroupDto>}
     * @memberof GlobalSearchResponse
     */
    groups: Array<GlobalSearchGroupDto>;
}

/**
 * Check if a given object implements the GlobalSearchResponse interface.
 */
export function instanceOfGlobalSearchResponse(value: object): value is GlobalSearchResponse {
    if (!('groups' in value) || value['groups'] === undefined) return false;
    return true;
}

export function GlobalSearchResponseFromJSON(json: any): GlobalSearchResponse {
    return GlobalSearchResponseFromJSONTyped(json, false);
}

export function GlobalSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'groups': ((json['groups'] as Array<any>).map(GlobalSearchGroupDtoFromJSON)),
    };
}

export function GlobalSearchResponseToJSON(json: any): GlobalSearchResponse {
    return GlobalSearchResponseToJSONTyped(json, false);
}

export function GlobalSearchResponseToJSONTyped(value?: GlobalSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groups': ((value['groups'] as Array<any>).map(GlobalSearchGroupDtoToJSON)),
    };
}

